"use strict";

exports.__esModule = true;
exports.TicketDetailsViewMode = TicketDetailsViewMode;
var _react = _interopRequireDefault(require("react"));
var _reactRouterDom = require("react-router-dom");
var _polished = require("polished");
var _core = require("@blueprintjs/core");
var _icons = require("@blueprintjs/icons");
var _StatusButtons = require("./StatusButtons");
var _TicketComments = require("./TicketComments");
var _Translator = require("../../Core/Translator");
var _AssigneeSection = require("./AssigneeSection");
var _CreatedAtSection = require("./CreatedAtSection");
var _WatchersSection = require("./WatchersSection");
var _CreatorSection = require("./CreatorSection");
var _PluginButtonBar = require("../../Plugins/PluginButtonBar");
var _PluginContext = require("../../Plugins/PluginContext");
var _System = require("../../../System");
var _TicketNumberSection = require("./TicketNumberSection");
var _AlertTicketTag = require("../../Core/AlertTicketTag");
var _DetailsComponent = require("../../Core/DetailsComponent");
var _StatusHistorySection = require("./StatusHistorySection");
var _getTranslatedTicketPriorities = require("../getTranslatedTicketPriorities");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function TicketDetailsViewMode(props) {
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  var _React$useContext2 = _react["default"].useContext(_PluginContext.PluginContext),
    plugins = _React$useContext2.plugins;
  var priorities = (0, _getTranslatedTicketPriorities.getTranslatedTicketPriorities)(translate);
  var ticketDetails = props.ticketDetails,
    updateTicketDetails = props.updateTicketDetails,
    ticketTypes = props.ticketTypes,
    setEditMode = props.setEditMode,
    width = props.width,
    height = props.height,
    createTicketComment = props.createTicketComment,
    editTicketComment = props.editTicketComment,
    deleteTicketComment = props.deleteTicketComment,
    onAssigneeClick = props.onAssigneeClick,
    onAssignToUser = props.onAssignToUser,
    onClose = props.onClose,
    refreshData = props.refreshData,
    ticketWithPopulatedTypes = props.ticketWithPopulatedTypes,
    isFullScreen = props.isFullScreen;
  var devices = ticketDetails.devices,
    title = ticketDetails.title,
    tags = ticketDetails.tags,
    status = ticketDetails.status,
    type = ticketDetails.type,
    created = ticketDetails.created,
    creator = ticketDetails.creator,
    assignee = ticketDetails.assignee,
    watchers = ticketDetails.watchers,
    comments = ticketDetails.comments,
    userId = ticketDetails.userId,
    assigneeId = ticketDetails.assigneeId,
    history = ticketDetails.history,
    id = ticketDetails.id,
    _ticketDetails$priori = ticketDetails.priority,
    priority = _ticketDetails$priori === void 0 ? "Medium" : _ticketDetails$priori;
  // TODO: Do this in the controller
  var selectedTypes = ticketTypes.filter(function (t) {
    return type.includes(t.id);
  });
  var translatedPriority = priorities.find(function (p) {
    return p.id === priority;
  });
  var allowEditMode = ticketDetails && Array.isArray(ticketDetails.links) && ticketDetails.links.length > 0 ? ticketDetails.links.some(function (link) {
    return plugins.find(function (plugin) {
      return plugin.allowEditWhen.includes(link.status);
    });
  }) : true;
  var style = {
    maxHeight: isFullScreen ? "unset" : "50px",
    overflow: "auto"
  };
  var ticketDetailsCenterContent = function ticketDetailsCenterContent() {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_DetailsComponent.DetailsSubSection, {
      heading: translate("TicketDetails.devices", "Devices"),
      content: /*#__PURE__*/_react["default"].createElement("p", {
        style: style
      }, devices.join(", "))
    }), /*#__PURE__*/_react["default"].createElement(_DetailsComponent.DetailsSubSection, {
      heading: translate("TicketDetails.tags", "Device Groups"),
      content: /*#__PURE__*/_react["default"].createElement(_AlertTicketTag.AlertTicketTag, {
        getKey: function getKey(tag) {
          return tag;
        },
        getValue: function getValue(tag) {
          return tag;
        },
        content: tags,
        style: style
      })
    }), /*#__PURE__*/_react["default"].createElement(_DetailsComponent.DetailsSubSection, {
      heading: translate("TicketDetails.types", "Types"),
      content: /*#__PURE__*/_react["default"].createElement(_AlertTicketTag.AlertTicketTag, {
        style: style,
        getKey: function getKey(tag) {
          return tag.id;
        },
        getValue: function getValue(tag) {
          return tag.value;
        },
        getColor: function getColor(tag) {
          return (0, _polished.readableColor)(tag.color);
        },
        getBackgroundColor: function getBackgroundColor(tag) {
          return tag.color;
        },
        content: selectedTypes
      })
    }), /*#__PURE__*/_react["default"].createElement(_DetailsComponent.DetailsSubSection, {
      heading: translate("TicketDetails.priority", "Priority"),
      content: /*#__PURE__*/_react["default"].createElement(_AlertTicketTag.AlertTicketTag, {
        style: style,
        getKey: function getKey(tag) {
          return tag.id;
        },
        getValue: function getValue(tag) {
          return tag.value;
        },
        getColor: function getColor() {
          return "#000000";
        },
        getBackgroundColor: function getBackgroundColor(tag) {
          return tag.color;
        },
        content: [translatedPriority]
      })
    }), /*#__PURE__*/_react["default"].createElement(_WatchersSection.WatchersSection, {
      watchers: watchers
    }));
  };
  var ticketDetailsContent = function ticketDetailsContent(isFullScreen) {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_DetailsComponent.DetailsSection, null, /*#__PURE__*/_react["default"].createElement(_TicketNumberSection.TicketNumberSection, {
      id: id,
      isFullScreen: isFullScreen
    }), /*#__PURE__*/_react["default"].createElement(_DetailsComponent.DetailsSubSection, {
      heading: translate("TicketDetails.description", "Summary"),
      content: title
    }), /*#__PURE__*/_react["default"].createElement(_CreatedAtSection.CreatedAtSection, {
      created: created
    }), /*#__PURE__*/_react["default"].createElement(_CreatorSection.CreatorSection, {
      creator: creator
    }), /*#__PURE__*/_react["default"].createElement(_AssigneeSection.AssigneeSection, {
      assignee: assignee,
      userId: userId,
      assigneeId: assigneeId,
      onChange: onAssigneeClick,
      onAssignToUser: onAssignToUser
    }), /*#__PURE__*/_react["default"].createElement(_StatusHistorySection.StatusHistorySection, {
      statusChangeHistory: history
    })), isFullScreen ? /*#__PURE__*/_react["default"].createElement(_DetailsComponent.DetailsSectionWide, null, ticketDetailsCenterContent()) : /*#__PURE__*/_react["default"].createElement(_DetailsComponent.DetailsSection, null, ticketDetailsCenterContent()));
  };
  return /*#__PURE__*/_react["default"].createElement(_DetailsComponent.DetailsContainer, {
    "data-testid": "NewTicketDetailsView",
    width: width,
    height: height,
    isFullScreen: isFullScreen
  }, /*#__PURE__*/_react["default"].createElement(_DetailsComponent.DetailsHeader, {
    isFullScreen: isFullScreen
  }, /*#__PURE__*/_react["default"].createElement(_DetailsComponent.HeaderButtonGroup, {
    style: {
      display: "flex"
    },
    isFullScreen: isFullScreen
  }, /*#__PURE__*/_react["default"].createElement(_StatusButtons.StatusButtons, {
    status: status,
    onChange: updateTicketDetails,
    disabled: !allowEditMode
  }), ticketWithPopulatedTypes ? /*#__PURE__*/_react["default"].createElement(_PluginButtonBar.PluginButtonBar, {
    context: ticketWithPopulatedTypes,
    onTicketLink: refreshData
  }) : null), /*#__PURE__*/_react["default"].createElement(_DetailsComponent.HeaderButtonGroup, {
    isFullScreen: isFullScreen
  }, isFullScreen ? null : /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: (0, _System.getScreenURL)("TicketDetails", {
      id: id
    }),
    target: "_blank",
    rel: "noreferrer noopener"
  }, /*#__PURE__*/_react["default"].createElement(_core.Button, {
    minimal: true,
    icon: _icons.IconNames.DOCUMENT_OPEN
  })), /*#__PURE__*/_react["default"].createElement(_core.Button, {
    "data-testid": "TicketEditIcon",
    minimal: true,
    icon: _icons.IconNames.EDIT,
    disabled: !allowEditMode,
    onClick: function onClick() {
      return setEditMode(true);
    }
  }), /*#__PURE__*/_react["default"].createElement(_core.Button, {
    minimal: true,
    icon: _icons.IconNames.CROSS,
    onClick: onClose
  }))), /*#__PURE__*/_react["default"].createElement(_DetailsComponent.DetailsSectionWrapper, {
    isFullScreen: isFullScreen
  }, isFullScreen ? /*#__PURE__*/_react["default"].createElement("div", null, ticketDetailsContent(isFullScreen)) : ticketDetailsContent(isFullScreen), /*#__PURE__*/_react["default"].createElement(_DetailsComponent.DetailsCommentsSection, null, /*#__PURE__*/_react["default"].createElement(_TicketComments.TicketComments, {
    comments: comments,
    ticketId: ticketDetails.id,
    onSubmit: createTicketComment,
    isFullScreen: isFullScreen,
    onCommentEdit: editTicketComment,
    onCommentDelete: deleteTicketComment
  }))));
}